<template>
    <div class="remind-wrapper">
        <div class="userAdd_man">
            <el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
                <el-form-item :label="t('scoreRemind.usageGuide')" prop="content">
                    <WangEditor ref="WangEditor_remind" @change="valueChange" />
                </el-form-item>
            </el-form>
        </div>
        <div class="dialog-footer">
            <el-button @click="reset">{{ t('common.reset') }}</el-button>
            <el-button type="primary" @click="submit">
                {{ t('common.confirm') }}
            </el-button>
        </div>
    </div>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
} from "vue";
import { ElMessage } from "element-plus";
import WangEditor  from "@/components/wang-editor"
import { detailApi, saveApi } from '@/api/attendance/remind'
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyScoreRemindRules } from "@/utils/scoreListI18n.js";

const WangEditor_remind = ref(null)

const state = reactive({
    dialogVisible: false,
    form: {
        "id": 2,
        "content": "",
    }
});

const rules = reactive({
    content: [
        { required: true, message: "", trigger: "blur" },
    ],
});

const applyLabels = () => {
    applyScoreRemindRules(rules);
};
const { t } = usePageI18n(applyLabels);

const getRemind = () => {
    const params = JSON.stringify({
        id: 2
    })
    detailApi(params).then(res => {
        if(res?.code === 200) {
            state.form = {
                ...res.data,
            }
            WangEditor_remind.value.setValue(res.data.content)
        }
    })
}

const valueChange = (html) => {
    state.form.content = html
}

const ruleForm = ref(null)
const submit = () => {
    ruleForm.value.validate((valid) => {
        if (valid) {
            const params = JSON.stringify(state.form)
            saveApi(params).then(res => {
                if(res?.code === 200) {
                    ElMessage.success(t('common.success'))
                }
            })
        } else {
            return false;
        }
    });
};

const reset = () => {
    state.form = {
        "id": 2,
        "content": "",
        "duration": 15,
    }
}

onMounted(() => {
    try {
        applyLabels();
        getRemind()
    } catch (error) {

    }
});

</script>

<style lang="less" scoped>
.remind-wrapper {

    width: 100%;
    height: 100%;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.userAdd_man {
    width: 70%;
    min-height: 200px;
    max-height: 600px;
    overflow: auto;
    padding: 0 30px;
}

.userFrom {
    width: 100%;
}

.el-form-item {
    margin-bottom: 0;
}

.tree_man {
    padding: 0 30px;
}
</style>
